import React, { useState } from 'react';

import { Box, Text, Select, FormControl, FormLabel } from '@chakra-ui/react';

import { useColors } from './colors';

const SupplierDropdown = ({ suppliers = [], selectedSupplier, onSupplierChange }) => {
  const {
    subTextColor: labelColor,
    textColor,
    bgColor,
    hoverBg,
    previewBg: selectFocusBg,
  } = useColors();

  const handleSupplierChange = (e) => {
    const supplierId = e.target.value;
    const selectedSupplierData = suppliers.find((s) => s.supplierId === supplierId);
    onSupplierChange?.(selectedSupplierData);
  };

  if (!suppliers.length) {
    return (
      <Box p={6} w="400px">
        <Text fontSize="sm" color={labelColor} fontStyle="italic">
          No suppliers available
        </Text>
      </Box>
    );
  }

  return (
    <Box p={6} w="400px">
      <FormControl>
        <FormLabel fontSize="sm" fontWeight="semibold" color={labelColor} mb={2}>
          Supplier
        </FormLabel>
        <Select
          value={selectedSupplier?.supplierId || ''}
          onChange={handleSupplierChange}
          size="md"
          borderRadius="md"
          sx={{
            option: {
              bg: bgColor,
              color: textColor,
              _hover: {
                bg: hoverBg + '!important',
              },
              _checked: {
                bg: hoverBg + '!important',
              },
            },
            _hover: {
              bg: hoverBg,
            },
            _focus: {
              bg: selectFocusBg,
            },
          }}
        >
          {suppliers.map((supplier) => (
            <option key={supplier.supplierId} value={supplier.supplierId}>
              {supplier.name || supplier.altName || 'Unknown Supplier'}{' '}
              {supplier.isSelected ? '(Selected)' : ''}
            </option>
          ))}
        </Select>
      </FormControl>

      <Text fontSize="xs" color={labelColor} mt={3}>
        The first supplier is currently selected for this listing. Other suppliers are
        shown for evaluation purposes.
      </Text>
    </Box>
  );
};

export default SupplierDropdown;
